import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ExpandingButton from "@/components/Buttons/ExpandingButton";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import logoImg from "@/assets/logos/white-penny-logo.png";
import vector from "@/assets/team/purple-background.png";
import useLocale from "@/hooks/useLocale";
import CustomSourceflowText from "@/components/Shared/CustomSourceflowText";

export default function TeamAboutSection() {
  const locale = useLocale();

  return (
    <div className="bg-jacarta flex items-center relative overflow-hidden 3xl:justify-between">
      <div className="pt-[55px] pb-[70px] px-8 lg:px-[82px] relative z-10">
        <h2 className="text-3xl sm:text-4xl xl:text-[50px]/[60px] 2xl:max-w-[600px] w-full ">
          <CustomSourceFlowText
            title="We are proud to be a LHi Group Company"
            path="dynamic1.teams.aboutheader"
            locale={locale}
          />
        </h2>
        <p className="text-xl/[30px] max-w-[520px] w-full pt-[22px] mb-8 3xl:max-w-[70%]">
          <CustomSourceFlowText
            title="LHi Group, established in 2002, is a global company with four non-competing specialist recruitment brands and a project delivery brand. Our brands include Lawrence Harvey (Technology), SciPro (Life Sciences), Harper Harrison (Built Environment), XPS (Project Delivery) and of course Piper Maddox (Clean Energy/Tech)."
            path="dynamic1.teams.aboutcontent"
            locale={locale}
          />
        </p>
        <ExpandingButton
          url="https://www.wearelhi.com/"
          color="white"
          bgColor="transparent"
          hoverBGColor="white"
          hoverColor="#150235"
        >
          <CustomSourceflowText
            path="dynamic1.teams.aboutcontent.learnmore"
            locale={locale}
            title={locale === "de" ? "Lerne mehr" : "Learn more"}
          />
        </ExpandingButton>
      </div>
      <div className="max-w-[341px] max-h-[351px] w-1/2 xl:w-full h-full relative z-10 hidden sm:block">
        <SourceFlowImage src={logoImg ?? ""} size="341x351" alt="logo" />
      </div>
      <img
        src={vector ?? ""}
        alt="vector"
        className="absolute right-[-50%] lg:right-0"
      />
    </div>
  );
}
